import moment from "moment";

import { encounterformType,  insuranceType, PostOfficeType } from "./Type/EncounterTypes";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance, { errorResponse } from "@services/services";
import { DepartmentTypes, DoctorsType } from "PatientCare/PatientBooking/v1/types";
import { ResponseType } from "Types/ServicesType/servicesType";
const {clinicId} = getConstants()
const {patientBookingApi,patientEncounterApi}= api;

export const getAllDepartments = async (): Promise<
  ResponseType<DepartmentTypes[]>
> => {
  try {
    const result = (
      await instance.get(`${patientBookingApi.getAllDepartments}${clinicId}`)
    ).data;
    return result;
  } catch (error: any) {
    if (error?.response?.data) {
      return error?.response?.data;
    } else {
      return { ...errorResponse, response: [] };
    }
  }
};

export const getDoctorsByDepartment = async ({
    departmentId
  }: {
    departmentId: number;
  }): Promise<ResponseType<DoctorsType[]>> => {
    try {
      const result = (
        await instance.post(`${patientBookingApi.getDoctorByDepartment}`, {
          clinicId,
          departmentId: departmentId,
          dayId:moment().day()
        })
      ).data;
      return result;
    } catch (error: any) {
      if (error?.response?.data) {
        return error?.response?.data;
      } else {
        return { ...errorResponse, response: [] };
      }
    }
  };


  export const getVisitPurpose = async (): Promise<
  ResponseType<any[]>
> => {
  try {
    const result = (
      await instance.get(`${patientEncounterApi.getPurpose}${clinicId}?status=1`)
    ).data;
    return result;
  } catch (error: any) {
    if (error?.response?.data) {
      return error?.response?.data;
    } else {
      return { ...errorResponse, response: [] };
    }
  }
};

  export const getpostOfficeService = async (): Promise<
  ResponseType<PostOfficeType[]>
> => {
  try {
    const result = (
      await instance.get(`${patientEncounterApi.postOfficeApi}${clinicId}`)
    ).data;
    return result;
  } catch (error: any) {
    if (error?.response?.data) {
      return error?.response?.data;
    } else {
      return { ...errorResponse, response: [] };
    }
  }
};
  export const getallClinician = async (): Promise<
  ResponseType<any[]>
> => {
  try {
    const result = (
      await instance.get(`${patientEncounterApi.getAllclinician}${clinicId}`)
    ).data;
    return result;
  } catch (error: any) {
    if (error?.response?.data) {
      return error?.response?.data;
    } else {
      return { ...errorResponse, response: [] };
    }
  }
};

export const getAllPatients =async (searchterm:string):Promise<ResponseType<any[]>>=>{
  try {
    const body={
      emrNo:searchterm,
      clinicId:clinicId
    }
    const result = (
      await instance.post(`${patientEncounterApi.getAllPatient}`,body)
    ).data;
    return result;
  } catch (error: any) {
    if (error?.response?.data) {
      return error?.response?.data;
    } else {
      return { ...errorResponse, response: [] };
    }
  }
}

export const getAllinsuranceType = async ():Promise<ResponseType<any[]>>=>{
  try {
    const result = (
      await instance.get(`${patientEncounterApi.getallinsType}${clinicId}`)
    ).data;
    return result;
  } catch (error: any) {
    if (error?.response?.data) {
      return error?.response?.data;
    } else {
      return { ...errorResponse, response: [] };
    }
  }
}
export const getinsuranceByType = async (id:number):Promise<ResponseType<any[]>>=>{

  try {
    const body={
      searchText:null,
      typeId:id,
      clinicId
    }
    const result = (
      await instance.post(`${patientEncounterApi.getInsByTpe}`,body)
    ).data;
    return result;
  } catch (error: any) {
    if (error?.response?.data) {
      return error?.response?.data;
    } else {
      return { ...errorResponse, response: [] };
    }
  }
}
export const getinsPlans = async (body:any):Promise<ResponseType<any[]>>=>{

  try {
    const result = (
      await instance.post(`${patientEncounterApi.getInsPlan}`,body)
    ).data;
    return result;
  } catch (error: any) {
    if (error?.response?.data) {
      return error?.response?.data;
    } else {
      return { ...errorResponse, response: [] };
    }
  }
}

export const getCptGroups = async ():Promise<ResponseType<any[]>>=>{
  try {
    const result = (
      await instance.get(`${patientEncounterApi.getcptgroups}${clinicId}`)
    ).data;
    return result;
  } catch (error: any) {
    if (error?.response?.data) {
      return error?.response?.data;
    } else {
      return { ...errorResponse, response: [] };
    }
  }
}

export const saveEncounter= async(body:{pMaster:encounterformType,insurance?:insuranceType,clinicId:number,copay?:any}):Promise<ResponseType<any[]>>=>{
  const result = (
    await instance.post(`${patientEncounterApi.saveEncounter}`,body)
  ).data;
  return result;
}